// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/turbulence.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/turbulence/turbulence.js';

mount([g0]);
